/**
 * Employee Web — `/me/travel` landing route.
 *
 * Phase 19 Plan 02. Permission gate: `travel:read:self`.
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";

export const Route = createFileRoute("/_auth/me/travel")({
  staticData: { breadcrumb: { labelKey: "expenses:me.travel.page.title" } },
  beforeLoad: requirePermission({
    anyOf: ["travel:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeTravelRoute,
});

// Pathless parent must render an <Outlet/> so the child routes (/me/travel/new,
// /me/travel/$id) display — the landing lives in the index route. Rendering the
// landing here made every child unreachable (same bug class as /me/loans).
function MeTravelRoute(): JSX.Element {
  return <Outlet />;
}
